import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  FormControl,
  InputLabel,
  MenuItem,
  Pagination,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Styles from "../../styles/vendorDashboard.module.css";

import { Cross, Search } from "../assets/icons";
import axios from "axios";
const getHeadCells = (role) => [
  { id: "city", label: "CITY ", width: 90 },
  { id: "address", label: "ADDRESS", width: 130 },
  { id: "storeManger", label: "STORE MANAGER ", width: 120 },
  { id: "product", label: "PRODUCT", width: 100 },
  { id: "dimension", label: "DIMENSIONS (L*B*D)", width: 130 },
  { id: "area", label: "AREA (SQ FT)", width: 100 },
  { id: "price", label: "PRICE (PER SQ FT)", width: 120 },
  { id: "totalPrice", label: "TOTAL PRICE(SQ FT)", width: 100 },
  { id: "baseMaterial", label: "BASE MATERIAL", width: 100 },
  { id: "printDetails", label: "PRINT DETAILS", width: 170 },
  { id: "oem", label: "OEM PREFERENCE", width: 130 },
  // { id: "Action", label: "ACTION", width: 90 },
];
var oldData = [];
function EnhancedTableToolbar(props) {
  const { numSelected } = props;
  return (
    <>
      <Toolbar className="mb-2 shadow-lg flex items-center">
        <Typography
          sx={{ flex: "1 1 auto" }} // Ensures it takes up as much space as needed
          variant="p"
          id="tableTitle"
          component="div"
        >
          Total SOW: {props.totalSOW}
        </Typography>

        <div className="flex items-center space-x-4 ml-auto">
          <div
            className="flex justify-center items-center rounded-full px-1 py-2 space-x-2 text-sm bg-[var(--secondary-color)] text-gray-900"
            style={{ border: "1px solid var(--listdown-color)" }}
          >
            <Search color="var(--listdown-color)" />
            <input
              type="text"
              className="outline-none"
              onSearchChange={props}
              placeholder={`Search`}
            />
          </div>

          <button
            className="px-2 py-1 w-36 text-[var(--primary-color)] border-[var(--primary-color)] border rounded-md"
            style={{ borderColor: "var(--primary-color)" }}
          >
            + Add Scope
          </button>
        </div>
      </Toolbar>
    </>
  );
}

function EnhancedTableHead(props) {
  const [headCells, setHeadCells] = useState([]);

  useEffect(() => {
    const role = localStorage.getItem("role");
    setHeadCells(getHeadCells(role));
  }, []);
  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell, index) => (
          <TableCell
            key={headCell.id}
            sx={{
              minWidth: headCell.width,
              height: 90,
              backgroundColor: "var(--light-primary-color)",
              fontWeight: "bold",
              borderRight:
                index < headCells.length - 1 ? "1px solid #ccc" : "none",
            }}
          >
            <span className="absolute top-3 text-[13px] font-semibold ">
              {" "}
              {headCell.label}{" "}
            </span>

            {["city"].includes(headCell.id) && (
              <input
                type="text"
                className="px-3 w-full py-1 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 mt-2"
                placeholder={`Search ${headCell.id}`}
                onChange={(e) => props.handleSearchChangeHead(e, headCell.id)} // Use the handler passed via props
                value={props.searchInputs?.[headCell.id] || ""} // Access search inputs from props
              />
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

const CampaignProductTable = ({
  isCampaignProductTable,
  campaignData,
  setIsCampaignProductTable,
}) => {
  console.log(campaignData._id);
  const [pageSize, setPageSize] = useState(20);
  const pageSizeOptions = [5, 10, 20, 50, 100];
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const serverURL = process.env.REACT_APP_URL;
  const [totalSOW, setTotalSOW] = useState("0");

  const [allSow, setAllSow] = useState([]);
  useEffect(() => {
    console.log("hello");
  }, []);
  const [sowListLoading, setIsSowLoading] = useState(false);
  const [searchInputs, setSearchInputs] = useState({
    state: "",
    city: "",
    phoneNumber: "",
    name: "",
  });
  const getSOWList = async (page = 1, limit = 20) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${serverURL}/jobs/getAllJobs`, {
        headers: { Authorization: `Bearer ${token}` },

        params: {
          campaignId: campaignData._id,
        },
      });

      if (response.data.success === true) {
        setAllSow(response.data.data);
        oldData = response?.data?.data;
        setTotalSOW(response.data.data.length);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getSOWList(page, pageSize);
  }, [page, pageSize]);

  const handleClose = () => {
    setIsCampaignProductTable(false);
  };
  const handlePageChange = async (e, value) => {
    await getSOWList(value, pageSize);
    setPage(value);
  };

  const handlePageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value));
    setPage(1);
  };
  const handleSearchChangeHead = (e, key) => {
    const value = e.target.value;
    console.log("value", value);
    const searchTerm = value.trim().replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    const searchKeyword = new RegExp(`\\b${searchTerm}\\w*\\b`, "i");
    // Update search inputs state for that particular field
    setSearchInputs((prevState) => ({
      ...prevState,
      [key]: value,
    }));

    // Check if the input is empty and reset the data to oldData
    if (searchKeyword === "") {
      setAllSow(oldData);
    } else {
      // Apply filtering based on the column (key)
      const filteredData = oldData.filter((data) => {
        // For each case, check if the key matches and perform filtering
        switch (key) {
          case "city":
            return searchKeyword.test(data?.city.toLowerCase());

          default:
            return true;
        }
      });

      setAllSow(filteredData);
    }
  };

  return (
    <div>
      <Dialog
        open={isCampaignProductTable}
        maxWidth={false} // Disable maxWidth restriction
        sx={{
          "& .MuiDialog-paper": {
            margin: 0, // Remove default margins
            width: "100vw", // Full viewport width
            height: "100vh", // Full viewport height
            maxWidth: "100vw", // Ensure no width limitation
            maxHeight: "100vh",
            borderRadius: "none", // Ensure no height limitation
            padding: "10px 20px ",
            backgroundColor: "var(--dashboard-bg-color)",
          },
        }}
      >
        {" "}
        <div className="flex justify-between">
          <h1 className="font-bold text-[20px] ml-10">Scope Of Work</h1>

          <div
            onClick={handleClose}
            className="mx-5 my-4"
            style={{ cursor: "pointer" }}
          >
            <Cross />
          </div>
        </div>
        <DialogContent sx={{ Width: "100%", margin: "auto" }}>
          <div className="bg-white h-full">
            <Box>
              {!sowListLoading ? (
                <>
                  <Paper sx={{ boxShadow: "none" }} className="px-10  ">
                    <EnhancedTableToolbar
                      showData={getSOWList}
                      onSearchChange={(value) => handleSearchChangeHead(value)}
                      totalSOW={totalSOW}
                    />
                    <>
                      <TableContainer
                        sx={{
                          height: "calc(79vh - 120px)", // Adjust this to control available space for the table
                          maxHeight: "calc(79vh - 120px)", // Ensures the table won't exceed this height
                          overflowY: "auto", // Adds scroll when the content exceeds height
                          width: "100%",
                        }}
                        className={`mt-2 rounded-lg  ${Styles["custom-scrollbar"]}`}
                      >
                        <Table
                          stickyHeader
                          // sx={{ minWidth: 750 }}
                          className="rounded-lg "
                        >
                          <EnhancedTableHead
                            userListData={getSOWList}
                            setSearchInputs={setSearchInputs} // Function to update search inputs
                            handleSearchChangeHead={handleSearchChangeHead}
                            searchInputs={searchInputs}
                          />
                          {allSow && allSow?.length > 0 ? (
                            <TableBody>
                              {allSow.map((v, index) => {
                                return (
                                  <TableRow
                                    hover
                                    sx={{ cursor: "pointer", height: "60px" }}
                                    tabIndex={-1}
                                  >
                                    <TableCell
                                      sx={{
                                        padding: "4px 8px",
                                        borderLeft: "1px solid #ccc",
                                        borderRight: "1px solid #ccc",
                                      }}
                                    >
                                      {v?.city || "NA"}
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        borderRight: "1px solid #ccc",
                                        padding: "4px 8px",
                                      }}
                                    >
                                      {v?.address || "NA"}
                                    </TableCell>

                                    <TableCell
                                      sx={{
                                        borderRight: "1px solid #ccc",
                                        padding: "4px 8px",
                                      }}
                                    >
                                      {v?.storeOwnerName}
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        borderRight: "1px solid #ccc",
                                        padding: "4px 8px",
                                      }}
                                    >
                                      {v?.productId?.productType}
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        borderRight: "1px solid #ccc",
                                        padding: "4px 8px",
                                      }}
                                    >
                                      {v?.productId?.productHeight +
                                        "*" +
                                        v?.productId?.productWidth +
                                        "*" +
                                        v?.productId?.productThickness}
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        borderRight: "1px solid #ccc",
                                        padding: "4px 8px",
                                      }}
                                    >
                                      {v?.productId?.productHeight *
                                        v?.productId?.productWidth}
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        borderRight: "1px solid #ccc",
                                        padding: "4px 8px",
                                      }}
                                    >
                                      {v?.productId?.price}
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        borderRight: "1px solid #ccc",
                                        padding: "4px 8px",
                                      }}
                                    >
                                      {v?.productId?.price *
                                        (v?.productId?.productHeight *
                                          v?.productId?.productWidth)}
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        borderRight: "1px solid #ccc",
                                        padding: "4px 8px",
                                      }}
                                    >
                                      {v?.productId?.baseMaterial}
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        borderRight: "1px solid #ccc",
                                        padding: "4px 8px",
                                      }}
                                    >
                                      {
                                        <div className="text-[var(--heading-color)]">
                                          <p className="text-[var(--heading-color)]">
                                            {v?.productId?.printType}
                                          </p>
                                          <p className="text-[var(--heading-color)]">
                                            {v?.productId?.printGSM}
                                          </p>
                                        </div>
                                      }
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        borderRight: "1px solid #ccc",
                                        padding: "4px 8px",
                                      }}
                                    >
                                      {v?.productId?.oemPreference}
                                    </TableCell>
                                  </TableRow>
                                );
                              })}
                            </TableBody>
                          ) : (
                            <div className="flex justify-center items-center h-64">
                              No SOW found
                            </div>
                          )}
                        </Table>
                      </TableContainer>
                      <hr
                        className="mt-2 bg-gray-200 "
                        style={{
                          border: "0.5px solid var(--light-grey-color)",
                        }}
                      />

                      <div className="flex items-center justify-between mt-3">
                        <FormControl
                          variant="standard"
                          size="small"
                          sx={{ minWidth: 80 }}
                        >
                          <InputLabel id="page-size-label">Rows</InputLabel>
                          <Select
                            labelId="page-size-label"
                            value={pageSize}
                            onChange={handlePageSizeChange}
                            label="Rows"
                          >
                            {pageSizeOptions.map((size) => (
                              <MenuItem key={size} value={size}>
                                {size}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        <Pagination
                          className="p-2 flex justify-center"
                          count={totalPages}
                          page={page}
                          onChange={handlePageChange}
                          sx={{
                            "& .MuiPaginationItem-root.Mui-selected": {
                              backgroundColor: "#418cff", // Blue background for selected
                              color: "#fff", // White text for selected
                            },
                            "& .MuiPaginationItem-root.Mui-selected:hover": {
                              backgroundColor: "#3366cc", // Darker blue on hover
                            },
                            "& .MuiPaginationItem-root": {
                              "&:hover": {
                                backgroundColor: "#ddd", // Light gray for hovered items
                              },
                            },
                          }}
                        />
                      </div>
                    </>
                  </Paper>
                </>
              ) : (
                <div className="flex justify-center items-center h-64">
                  <CircularProgress />
                </div>
              )}
            </Box>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default CampaignProductTable;
